import GradientBorder from "@core-components/gradient-border/GradientBorder";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Button, Group, TextInput } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";
import type { GetInputPropsReturnType } from "node_modules/@mantine/form/lib/types";
import { type ReactNode, useState } from "react";

type ICodeInputProps = {
  resetValidity: () => void;
  onValidate: () => void;
  isValid: boolean;
  buttonLabel: string;
  icon: ReactNode;
  isDirty: boolean;
} & GetInputPropsReturnType;

const CodeInput: React.FC<ICodeInputProps> = ({
  resetValidity,
  onValidate,
  isValid,
  buttonLabel,
  icon,
  value,
  onChange,
  isDirty,
  ...rest
}) => {
  const { t } = useAppTranslation("pages.order.basket.codeInput");
  const [isInputVisible, toggleVisibility] = useState<boolean>(false);

  const handleChange = (value: string) => {
    onChange(value);
    resetValidity();
  };

  return (
    <>
      {!isInputVisible && (
        <GradientBorder className="gradient-gray-to-light-white hover-scale rounded-full">
          <Button
            onClick={() => toggleVisibility((o) => !o)}
            color="#1d1e23"
            className="rounded-full font-inter"
            leftSection={icon}
          >
            {buttonLabel}
          </Button>
        </GradientBorder>
      )}

      {isInputVisible && (
        <Group className="w-full">
          <TextInput
            rightSection={
              value &&
              !isDirty &&
              (isValid ? (
                <IconCheck color="#00B67A" />
              ) : (
                <IconX color="#BB1111" />
              ))
            }
            classNames={{
              root: "flex-1",
              input:
                "bg-primary-darker border-primary-lighter text-primary-light-text rounded-lg disabled:bg-primary-default",
            }}
            placeholder={t("placeholder")}
            value={value}
            onChange={(e) => handleChange(e.target.value)}
            {...rest}
          />

          <GradientBorder className="gradient-gray-to-light-white hover-scale rounded-lg">
            <Button
              color="#1d1e23"
              className="rounded-lg font-inter"
              leftSection={icon}
              onClick={onValidate}
            >
              {t("validate")}
            </Button>
          </GradientBorder>
        </Group>
      )}
    </>
  );
};

export default CodeInput;
